export const config= {
    placeholderText: 'Edit Your Content Here!',
    key: "FROALA_KEY",
    attribution: false,
    height: '350px',
    width:800,
    pluginsEnabled: [
        'fullscreen',
        'codeBeautifier',
        'colors',
        'fontFamily',
        'fontSize',
        "paragraphFormat", 
        "paragraphStyle",
        "align",
        "lists",
        "table"
      ],
    toolbarButtons: {
        moreText: {              
          buttons: [  
            'undo', 'redo',
            "|",
            "paragraphFormat",
            "|",
            'fontFamily',
            "|",
            'fontSize',
            "|",
            'bold',
            'italic',
            'underline',
            'strikeThrough',
            'clearFormatting',
            "|",  
            'textColor',
            'backgroundColor',
            "|",
            'alignLeft',
            'alignCenter',
            'alignRight',
            'alignJustify',
            // 'inlineClass',
            // 'inlineStyle',
            "formatOL",
            "formatUL",
            "outdent",
            "indent",
            "|",
            "insertTable",
            "|",
            "copy",

          ],
          align: 'left',
          buttonsVisible: 27,
        },
        // moreParagraph: {
        //     buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
        //     align: 'left',
        //     buttonsVisible: 10
        //   },
      
          // moreRich: {
          //   buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
          //   align: 'left',
          //   buttonsVisible: 10
          // },
      
        //   moreMisc: {
        //     buttons: [ "copy",'fullscreen', 'print','copyToClipboard', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
        //     align: 'right',
        //     buttonsVisible: 10
        //   }
    },
    // events: {
    //   'click': function (clickEvent) {
    //    // setShowToast(false);
    //     console.log(this);
    //   }
    // }
}

export const radiotemplateOptions = [
    {
      key: 'deeptekReportTemplage',
      text:"Deeptek Report Template",
    },
    {
      key: 'rsnaReportTemplage',
      text:"RSNA Report Template",
    },
    {
      key: 'radiologistReportTemplate',
      text:"Radiologist Report Template",
    },
  ];

  export const allReportTemplateCategory = [
    {
      key: 'clientReportTemplate',
      text:"Client Report Template",
    },
    {
      key: 'deeptekReportTemplage',
      text:"Deeptek Report Template",
    },
    {
      key: 'rsnaReportTemplage',
      text:"RSNA Report Template",
    },
    {
      key: 'radiologistReportTemplate',
      text:"Radiologist Report Template",
    },
  ];

  export const clientReportTemplate = [
    {
      key: 'clientReportTemplate',
      text:"Client Report Template",
    }
  ];

  export const radiotemplateWithoutRSNAOptions = [
    {
      key: 'deeptekReportTemplage',
      text:"Deeptek Report Template",
    },
    {
      key: 'radiologistReportTemplate',
      text:"Radiologist Report Template",
    },
  ];

 export const circlStyle = {
    'circle':{width:'40px',height:'40px',borderWidth: '3.5px'}
   }

export const dropdownStyles = {
    dropdown: { width: 200,background:"black",broderRadius:0 },
    title:{
        border: '1px solid #C8C6C4',
        borderRadius: '10px',
        background:'none',
        height:'29px',
        display:'flex',
        alignItem:'center'
    },
    dropdownItems: {
      selectors: {
        "@media(min-width: 640px)": {
          maxHeight: 300,
        },
      },
    },
  };

export const choiceGroupStyles = {
    label: {
      display: "inline",
      paddingLeft: "10px",
    },
    flexContainer: {
      root:{
        marginTop: "0px"
      },
      field:{
        root:{
          marginTop:"0px"
        }
        
      },
      columnGap: "1.5em",
      display: "inline-flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
  };

  export const covidReportState = {
    selectedVal: null,
    selectedText: null,
    sentences_map: {
      Linear: "Linear opacities in the $locations lung in the $zones zone and $distributions distribution.",
      Reticular: "Reticular opacities in the $locations lung in the $zones zone and $distributions distribution.",
      ReticuloNodular: "Reticulo-nodular opacities in the $locations lung in the $zones zone and $distributions distribution.",
      Nodular: "Nodular opacities in the $locations lung in the $zones zone and $distributions distribution.",
      GOO: "Ground glass opacities in the $locations lung in the $zones zone and $distributions distribution.",
      ReverseHalo: "Reverse halo opacities in the $locations lung in the $zones zone and $distributions distribution.",
      Consolidation: "Consolidation opacities in the $locations lung in the $zones zone and $distributions distribution.",
      Cavitation: "Foci of cavitation in the $locations lung in the $zones zone and $distributions distribution.",
      Fibrosis: "Fibrosis in the $locations lung in the $zones zone and $distributions distribution.",
      TreeInBud: "Tree in bud in the $locations lung in the $zones zone and $distributions distribution.",
      Honeycombing: "Honeycombing in the $locations lung in the $zones zone and $distributions distribution.",
      TractionBronchiectasis: "Traction bronchiectasis in the $locations lung in the $zones zone and $distributions distribution.",
      ArchitecturalDistortion: "Architectural distortion in the $locations lung in the $zones zone and $distributions distribution.",
      CentrilobularEmphysema: "Centrilobular emphysema in the $locations lung in the $zones zone and $distributions distribution.",
      ParaseptalEmphysema: "Paraseptal emphysema in the $locations lung in the $zones zone and $distributions distribution.",
      PanlobularEmphysema: "Panlobular emphysema in the $locations lung in the $zones zone and $distributions distribution.",
      Paracicatricial: "Paracicatricial opacities in the $locations lung in the $zones zone and $distributions distribution.",
      Localized: "Localized in the $locations lung in the $zones zone and $distributions distribution.",
      Prevascular: "$Solitary enlarged $Multiple enlarged prevascular lymph node measuring $size mm.",
      Paratracheal: "$Solitary enlarged $Multiple enlarged paratracheal lymph node measuring $size mm.",
      Subaortic: "$Solitary enlarged $Multiple enlarged subaortic lymph node measuring $size mm.",
      Subcarinal: "$Solitary enlarged $Multiple enlarged subcarinal lymph node measuring $size mm.",
      Paraesophageal: "$Solitary enlarged $Multiple enlarged paraesophageal lymph node measuring $size mm.",
      Retrocrural: "$Solitary enlarged $Multiple enlarged retrocrural lymph node measuring $size mm.",
      Hilar: "$Solitary enlarged $Multiple enlarged hilar lymph node measuring $size mm.",
      Segmental: "$Solitary enlarged $Multiple enlarged segmental lymph node measuring $size mm.",
      Subsegmental: "$Solitary enlarged $Multiple enlarged subsegmental lymph node measuring $size mm.",
    },
  };

